if (!customElements.get('product-inventory')) {
    class ProductInventory extends HTMLElement {
        constructor() {
            super();
            if (this.hidden) {
                this.initLazySection();
            } else {
                window.initLazyScript(this, this.initLazySection.bind(this));
            }
        }

        initLazySection() {
            this.inventoryNotice = this.querySelector('.js-inventory-notice');
            this.urgencyMessage = this.querySelector('.js-inventory-urgency');
            this.indicatorBar = this.querySelector('.js-inventory-indicator');
            this.variantInventory = this.getVariantInventory();

            // Bind to on:variant:change event for this product
            const variantPicker = this.closest('.product-info').querySelector('variant-picker');

            if (variantPicker) {
                variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));

                this.handleVariantChange(new CustomEvent('on:variant:change', {
                    detail: {
                        variant: variantPicker.getSelectedVariant()
                    }
                }));

                return;

            } else {
                const inventory = this.variantInventory[0];

                if(inventory.hasOwnProperty('delivery_time') && inventory.hasOwnProperty('inventory_level')) {
                    this.updateInventory(
                        inventory.delivery_time,
                        inventory.inventory_level
                    );

                    return;
                }
            }

            this.hidden = true;
        }

        /**
         * Gets the inventory data for all product variants
         * @returns {?object}
         */
        getVariantInventory() {
            const dataEl = this.querySelector('[type="application/json"]');
            return this.variantInventory || JSON.parse(dataEl.textContent);
        }

        /**
         * Handles a 'change' event on the variant picker element
         * @param {object} evt - Event object
         */
        handleVariantChange(evt) {
            if (evt.detail.variant) {

                const inventory = this.variantInventory.filter(
                    (variant) => variant.id === evt.detail.variant.id
                )[0];

                if(inventory.hasOwnProperty('delivery_time') && inventory.hasOwnProperty('inventory_level')) {
                    this.updateInventory(
                        inventory.delivery_time,
                        inventory.inventory_level
                    );

                    return;
                }
            }

            this.hidden = true;
        }

        /**
         *
         * Updates the inventory notice
         * @param {string} delivery_time - delivery time text
         * @param {string} inventory_level - inventory level
         */
        updateInventory(delivery_time, inventory_level) {

            this.inventoryNotice.innerText = delivery_time;

            // Set the inventory level data attribute
            this.setAttribute('data-inventory-level', inventory_level);

            this.hidden = false;
        }
    }

    customElements.define('product-inventory', ProductInventory);
}